import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Creative Burnout',
  description: 'You spend hours searching YouTube, coaching websites, and social media looking for drills and exercises that somehow fit together.'
}, {
  emoji: '🍃',
  title: 'Lack Of Structure',
  description: 'Your sessions lose flow. You jump from drill to drill and wonder if your players are actually progressing in a logical, age-appropriate way.'
}, {
  emoji: '📱',
  title: 'Information Overload',
  description: "You search online and find thousands of conflicting ideas. Everyone teaches something different, and you don't know which system actually works for youth development."
}, {
  emoji: '😩',
  title: 'Massive Mental Load',
  description: 'Managing players, planning practices, organizing court time, and preparing game days leaves you exhausted before practice even begins.'
}];
export function PainPoints() {
  return <section className="relative border-t border-navy-800 bg-navy-950 py-12 md:py-20" data-id="element-167">
      <div className="container mx-auto px-4" data-id="element-168">
        <div className="mx-auto mb-10 max-w-4xl text-center md:mb-16" data-id="element-169">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-5 font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:mb-6 md:text-5xl" data-id="element-170">
            DOES THIS SOUND FAMILIAR?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg font-medium text-gray-400 sm:text-xl" data-id="element-171">
            You love coaching basketball, but planning practices is taking over
            all your free time.
            <br className="hidden md:block" data-id="element-172" />
            If you&apos;re a basketball coach, you&apos;ve probably experienced
            one of these situations:
          </motion.p>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-4 md:grid-cols-2 md:gap-6" data-id="element-173">
          {painPoints.map((point, index) => <motion.article key={point.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-navy-800 bg-navy-900/50 p-5 sm:p-6 md:p-8" data-id="element-174">
              <div className="mb-3 text-3xl md:mb-4 md:text-4xl" data-id="element-175">
                {point.emoji}
              </div>
              <h3 className="mb-2 font-oswald text-xl uppercase tracking-normal text-white md:mb-3 md:text-2xl md:tracking-wide" data-id="element-176">
                {point.title}
              </h3>
              <p className="leading-relaxed text-gray-400" data-id="element-177">
                {point.description}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}